import { render } from "./ColorSample.vue?vue&type=template&id=5f8c6708&scoped=true&ts=true"
import script from "./ColorSample.vue?vue&type=script&lang=ts"
export * from "./ColorSample.vue?vue&type=script&lang=ts"

import "./ColorSample.vue?vue&type=style&index=0&id=5f8c6708&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f8c6708"]])

export default __exports__